import * as React from 'react';
import { Row, Col, Icon, Button, Tooltip, message } from 'antd';
import injectSheet from 'react-jss';
import { withRouter } from 'react-router';
import { getInquiryCreateBidRoute } from 'src/routing/utils';
import FFBidCard from './Cards/FFBidCard';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setFilter, applyFilter, resetFilters, getBidsFF } from 'src/actions/inquiryFFActionBids';
import { downloadFileData } from 'src/utils/utils';
import {
  downloadBidsForFF,
  downloadBidsForShipper,
  rejectInquiryFF,
  getRank1Price,
} from 'src/api/inquiry';
import Loader from 'src/components/common/Loader';
import LightHouseIcon from 'src/components/common/icons/LightHouseIcon';
import BidsSortByModal from './Modals/BidsSortByModal';
import FFBidsFilterModal from './Modals/FFBidsFilterModal';
import SortIcon from 'src/components/common/icons/SortIcon';
import moment from 'moment';
import withInquiryMasterData from './hoc/InitInquiryMaster';
import { INQUIRY_FF } from 'src/utils/partsToShow/partsConstants';
import withAuthAccessExim from 'src/components/hoc/withAuthAccessExim';
import TaxWarning from './../../common/TaxWarning';
import { EventCategories, sendEvent } from 'src/utils/gaService';
import { isValidArray } from 'src/Library/Helper';
import FFInquiryRejectModal from './Modals/FFInquiryRejectModal';
import {
  getDeadlineData,
  rejectInquiryShown,
  prettifyInquiryMode,
  getUnitByMode,
} from './InquiryUtils';
import FFRevokeInquiryModal from './Modals/FFRevokeInquiryModal';
import { InquiryModes } from 'src/Library/Constants';
import { getRefRateUnit } from './Cards/InquiryCommon';
import { tokens } from 'src/design-system';

const COLORS = {
  GREEN: '#52C41A',
  RED: '#F5222D',
  BLUE: tokens.colors.primary,
  GREY: '#F9F9F9',
  LIGHTGREY: '#D9D9D9',
};
const styles = (theme) => ({
  parentDiv: {
    '& .ant-btn': {
      boxShadow: '0 0 0 rgba(0,0,0,0) !important',
    },
  },
  tabpane: {
    '& .ant-tabs-tab ': {
      marginBottom: '0 !important',
      paddingBottom: '16px !important',
      paddingTop: '0px !important',
      paddingLeft: '24px !important',
      textAlign: 'left !important',
      paddingRight: '233px !important',
    },
  },
  tab: {
    marginBottom: '0px',
    paddingTop: '4px',
  },
  shadow: {
    border: '1px solid #D9D9D9',
    opacity: '0.5',
    marginLeft: '0px',
  },
  shadow2: {
    border: '1px solid #D9D9D9',
    width: '100%',
    opacity: '0.5',
    marginLeft: '0px',
    marginRight: 'auto',
  },
  paragraph: {
    fontsize: '11px',
    paddingLeft: '24px',
    paddingTop: '17px',
    fontfamily: 'Open Sans',
  },
  anchorTags: {
    fontsize: '11px',
    paddingLeft: '24px',
    paddingTop: '17px',
    fontfamily: 'Open Sans SemiBold',
    color: tokens.colors.primary,
    display: 'block',
    fontWeight: `${tokens.fontWeight.semibold}`,
  },
  darkFont: {
    color: '#262626 ',
    font: '18px Open Sans',
  },
  row2: {
    '& .ant-row': {
      marginLeft: '5px !important',
      paddingLeft: '0px !important',
    },
  },
  verticalLine: {
    border: '1px solid #D9D9D9',
    height: '37px',
    width: '2px',
  },
  notFound: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  errorBlock: {
    margin: '15px',
  },
  rightHeader: {
    marginRight: '12px',
    marginTop: '16px',
    fontSize: `${tokens.fontSize.h1}px`,
    display: 'flex',
  },
  taxWarning: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    padding: '0px 15px 10px 0px',
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  rrContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
  },
  rrBasis: {
    fontSize: `${tokens.fontSize.small}px`,
    color: '#272727',
    fontWeight: 'normal',
    marginRight: '5px',
    alignSelf: 'flex-end',
    lineHeight: '12px',
    flexShrink: '0',
  },
  rrCurrency: {
    fontSize: `${tokens.fontSize.caption}px`,
    alignSelf: 'flex-start',
    fontWeight: 'bold',
    lineHeight: '10px',
    flexShrink: '0',
  },
  rrAmount: {
    fontSize: `${tokens.fontSize.h3}px`,
    fontWeight: 'bold',
    marginRight: '5px',
    alignSelf: 'flex-start',
    lineHeight: '16px',
    flexShrink: '0',
  },
  rrContainerType: {
    fontSize: `${tokens.fontSize.caption}px`,
    alignSelf: 'flex-end',
    lineHeight: '10px',
    flexShrink: '0',
  },
  rejectInquiryText: {
    marginRight: '8px',
    fontSize: `${tokens.fontSize.body}px`,
    color: '#F84307',
    width: '98px',
    paddingTop: '8px',
  },
  highValue: {
    backgroundColor: '#1990ff',
    padding: '5px',
    borderRadius: '5px',
    color: 'white',
    height: '15px',
    fontSize: '8px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
    width: 'max-content',
    marginTop: '5px'
  }
});
class FFInquiry extends React.PureComponent<any, any> {
  state: any = {
    bidConfirmed: false,
    filterModalVisible: false,
    bidsSortByModalVisible: false,
    fileError: '',
    fileLink: '',
    clearVisible: false,
    isInquiryDataLoading: false,
    inquiryRejectModalVisible: false,
    isCardLoading: false,
    revokeInquiryModalVisible: false,
    rank1BidInfo: undefined,
  };

  //interval for auto refresh
  interval: NodeJS.Timeout;

  componentDidMount() { 
    this.loadBidData(true); 
    this.interval = setInterval(() => { 
      this.loadBidData(false)
    }, 60000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  loadBidData = async (applyFilter) => {
    const { showGapForRank1AllBid, showGapForRank1, inquiryData } = this.props;
    const { id: inquiryId } = inquiryData;
    this.props.getBidsFF(inquiryId, applyFilter);
    if (showGapForRank1AllBid || showGapForRank1){
      const response = await getRank1Price(inquiryId);
      if (response.isSuccess) this.setState({ rank1BidInfo: response.data });
      else message.error(response.errorMessage);
    }
  }

  clearFilters = () => {
    this.props.resetFilters(this.props.inquiryData.id);
    this.setState({
      bidsFilterModalVisible: false,
    });
  };

  handleAddBid = (inquiryId) => {
    if (this.props.inquiryData?.isDeadLinePassed) return;
    sendEvent(EventCategories.INQUIRY_BIDDING, 'Add Bid - Clicked', 'FF Bids List View');
    const { history } = this.props;
    history.push(getInquiryCreateBidRoute(inquiryId), 'fromBids');
  };

  handleRejectInquiry = async (reasons, remarks) => {
    const { id: inquiryId } = this.props.inquiryData;
    this.setState({ isCardLoading: true });
    const response = await rejectInquiryFF({ inquiryId, reasons, remarks });
    if (response.isSuccess) {
      this.setState({ inquiryRejectModalVisible: false });
      this.handleLoadInquiry();
    } else {
      message.error(response.errorMessage);
    }
    this.setState({ isCardLoading: false });
  };

  handleCancel = () => this.setState({ inquiryRejectModalVisible: false });

  handleDownload = async (body) => {
    let res: any;
    this.setState({ isDownloadLoading: true });
    if (this.props.userType === 'SHIPPER') {
      res = await downloadBidsForShipper(body);
    } else {
      res = await downloadBidsForFF(body);
    }
    if (res.isSuccess) {
      const link = downloadFileData(res.data, res.filename);
      this.setState({ fileLink: link });
      message.success('Downloaded Successfully.');
    } else {
      message.error(res.errorMessage || 'No Bids to Download.');
    }
    this.setState({
      fileError: res.errorMessage,
    });
    this.setState({ isDownloadLoading: false });
  };

  renderNoData = () => {
    const { classes, theme, inquiryData, permission } = this.props;
    const { clearVisible: filterSelected } = this.state;
    const { status, isRejected } = inquiryData;
    const isDisabled = !(status === 'OPEN' && permission);
    let titleMessage = 'No bid Created';
    if (filterSelected) {
      titleMessage = 'No bid Found';
    }
    if (isRejected) {
      titleMessage = 'Declined Inquiry';
    }
    return (
      <div className={classes.notFound}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            marginTop: '12%',
          }}
        >
          <div className={classes.notFoundItems}>
            <LightHouseIcon className={classes.blackIcon} width="184" height="184"></LightHouseIcon>
          </div>
          <div className={classes.notFoundItems} style={{ fontWeight: tokens.fontWeight.semibold, fontSize: 16 }}>
            {titleMessage}
          </div>
          <div className={classes.notFoundItems} style={{ paddingTop: 10, fontSize: 14 }}>
            {isRejected ? 'To participate in the inquiry, please ' : 'To get more results, '}
            <span
              onClick={() => (!isDisabled ? this.handleRevokeAddBid() : undefined)}
              style={
                !isDisabled
                  ? {
                      color: theme.primaryColor,
                      cursor: 'pointer',
                    }
                  : undefined
              }
            >
              {`${isRejected ? 'Revoke & ' : ''} Add bid`}
            </span>
            {!isRejected ? ' or try adjusting your filters.' : '.'}
          </div>
        </div>
      </div>
    );
  };

  handleRevokeAddBid = () => {
    const {
      inquiryData: { isRejected, id },
    } = this.props;
    if (isRejected) {
      this.setState({ revokeInquiryModalVisible: true });
    } else {
      this.handleAddBid(id);
    }
  };

  handleOkFF = () => {
    this.setState({ bidsFilterModalVisible: false });
    this.props.applyFilter(this.props.inquiryData.id);
  };

  handleCancelFF = () => {
    this.setState({ bidsFilterModalVisible: false });
    this.props.setFilter({
      shippingLineList: this.props.appliedFilters.shippingLineList,
      bidStatusList: this.props.appliedFilters.bidStatusList,
    });
  };

  renderRateValue() {
    const { inquiryData, currencies, referenceRateBasis, classes } = this.props;
    const { mode, referenceRate } = inquiryData;
    if (!mode || !referenceRate || !referenceRate.amount) return '-';
    return (
      <div className={classes.rrContainer}>
        {mode !== InquiryModes.TRAILER && (
          <span className={classes.rrBasis}>{referenceRateBasis[referenceRate.basis]}</span>
        )}
        <span className={classes.rrCurrency}>{currencies[referenceRate.currency]}</span>
        <span className={classes.rrAmount}>{Number(referenceRate.amount).toFixed(2)}</span>
        <span className={classes.rrContainerType}>{getRefRateUnit(mode)}</span>
      </div>
    );
  }

  renderReferenceRateForFF() {
    const { classes } = this.props;
    return (
      <div className={classes.flexRow} style={{ width: '24%', padding: '10px 0px' }}>
        <div className={classes.verticalLine} style={{ marginRight: 20 }}></div>
        <div className={classes.flexColumn} style={{ width: '98%', fontSize: `${tokens.fontSize.small}px` }}>
          <span>Reference Rate</span>
          {this.renderRateValue()}
        </div>
      </div>
    );
  }

  renderRejectInquiry = () => {
    const { classes, inquiryData } = this.props;
    const { referenceNumber, deadline, status } = inquiryData;
    return (
      <React.Fragment>
        <a
          style={{
            color: status === 'CLOSED' ? '#AAAAAA' : '#F84307',
            cursor: status === 'CLOSED' ? 'not-allowed' : 'pointer',
          }}
          className={classes.rejectInquiryText}
          onClick={
            status !== 'CLOSED'
              ? () => this.setState({ inquiryRejectModalVisible: true })
              : undefined
          }
        >
          Decline Inquiry
        </a>
        <FFInquiryRejectModal
          loading={this.state.isCardLoading}
          visible={this.state.inquiryRejectModalVisible}
          handleCancel={this.handleCancel}
          deadlineDate={deadline}
          inquiryReferenceNumber={referenceNumber}
          handleRejectInquiry={this.handleRejectInquiry}
        />
      </React.Fragment>
    );
  };

  renderFiltersForFF() {
    const { classes, appliedFilters, pagination, inquiryData, permission } = this.props;
    const defaultSortBy = {
      sortBy: 'transit_time',
      descendingOrder: false,
    };
    const { isRejected, bidsSaved, bidsSent, status, deadline, isDeadlinePassed } = inquiryData;
    const showRejectInquiry = rejectInquiryShown(bidsSaved, bidsSent, isRejected);
    if (!inquiryData) return <div></div>;
    const bidIdList = appliedFilters.bidIdList && appliedFilters.bidIdList.length ? 1 : 0;
    const shippingApplied =
      appliedFilters.shippingLineList && appliedFilters.shippingLineList.length > 0 ? 1 : 0;
    const bidStatus =
      appliedFilters.bidStatusList && appliedFilters.bidStatusList.length > 0 ? 1 : 0;
    const { clearVisible } = this.state;
    const totalCnt = shippingApplied + bidIdList + bidStatus;
    const sortByOrderChanged = !(
      defaultSortBy.sortBy === appliedFilters.sortBy &&
      defaultSortBy.descendingOrder === appliedFilters.descendingOrder
    );
    totalCnt > 0 || sortByOrderChanged
      ? this.setState({ clearVisible: true })
      : this.setState({ clearVisible: false });
    const downloadRequest = {
      shippingLineList: (appliedFilters.shippingLineList && appliedFilters.shippingLineList) || [],
      bidStatusList: (appliedFilters.bidStatusList && appliedFilters.bidStatusList) || [],
      sortBy: appliedFilters.sortBy || 'transit_time',
      inquiryId: inquiryData.id,
      currentPageNumber: pagination.currentPageNumber ? pagination.currentPageNumber : 1,
    };
    const currentTime = new Date().getTime();
    // const isDeadLinePassed = currentTime - (deadline || Number.POSITIVE_INFINITY) >= 0 ? true : false
    const isDeadLinePassed = isDeadlinePassed;
    const isDisabled = isDeadLinePassed || !permission;
    const isFilterApplied =
      isValidArray(appliedFilters.shippingLineList) ||
      isValidArray(appliedFilters.bidStatusList) ||
      isValidArray(appliedFilters.bidIdList);
    return (
      <div style={{ width: '50%' }}>
        <Col span={1}>
          <div
            className={classes.verticalLine}
            style={{
              marginLeft: '15px',
              marginTop: '12px',
            }}
          ></div>
        </Col>
        <Col span={11} className={classes.flexRow} style={{ marginTop: '18px' }}>
          <span
            style={{
              marginLeft: '15px',
              height: '24px',
              cursor: 'pointer',
            }}
            onClick={() => this.setState({ bidsFilterModalVisible: true })}
          >
            <Tooltip title="Filters">
              <Icon
                type="filter"
                style={{ color: isFilterApplied ? tokens.colors.primary : '#424242', fontSize: `${tokens.fontSize.h3}px` }}
                theme={isFilterApplied ? 'filled' : 'outlined'}
              />
            </Tooltip>
            {totalCnt > 0 ? (
              <span style={{ marginLeft: '8px', fontWeight: 600 }}>({totalCnt})</span>
            ) : (
              <span></span>
            )}
          </span>
          <FFBidsFilterModal
            visible={this.state.bidsFilterModalVisible}
            handleOk={this.handleOkFF}
            handleCancel={this.handleCancelFF}
            inquiryMode={this.props.inquiryData.mode}
          />
          <span
            style={{
              height: '24px',
              marginLeft: '26px',
              cursor: 'pointer',
            }}
            onClick={() => this.setState({ bidsSortByModalVisible: true })}
          >
            <Tooltip title="Sort By">
              <SortIcon
                style={{
                  height: '14px',
                  width: '16px',
                }}
              />
            </Tooltip>
          </span>
          {clearVisible ? (
            <div
              style={{
                marginLeft: '20px',
                cursor: 'pointer',
              }}
              onClick={this.clearFilters}
            >
              <span style={{ color: tokens.colors.primary, cursor: 'pointer', fontWeight: 600 }}>
                Clear Filters
              </span>
            </div>
          ) : (
            <div />
          )}
          <BidsSortByModal
            visible={this.state.bidsSortByModalVisible}
            handleCancel={() => this.setState({ bidsSortByModalVisible: false })}
            id={inquiryData.id}
            mode={inquiryData.mode}
          />
        </Col>
        <Col span={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div className={classes.rightHeader}>
            <Tooltip title="Reload">
              <Button
                icon="reload"
                onClick={this.loadBidData}
              ></Button>
            </Tooltip>
            <div style={{ fontSize: '24px', marginRight: '24px', marginLeft: '24px' }}>
              <Icon
                style={{
                  color: this.state.isDownloadLoading ? COLORS.LIGHTGREY : undefined,
                  cursor: this.state.isDownloadLoading ? 'default' : 'pointer',
                }}
                type="download"
                onClick={
                  this.state.isDownloadLoading
                    ? undefined
                    : () => this.handleDownload(downloadRequest)
                }
              />
              <span>{this.state.fileLink}</span>
            </div>
            {showRejectInquiry && this.renderRejectInquiry()}
            {permission &&
              (isRejected ? (
                <a
                  style={{
                    color: isDisabled ? '#AAAAAA' : tokens.colors.primary,
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                    fontSize: `${tokens.fontSize.body}px`,
                    marginTop: '6px',
                  }}
                  onClick={() => !isDisabled && this.setState({ revokeInquiryModalVisible: true })}
                >
                  Revoke & Add Bid
                </a>
              ) : (
                <div>
                  <Button
                    disabled={isDisabled}
                    style={
                      isDisabled ? undefined : { backgroundColor: tokens.colors.primary, border: tokens.colors.primary }
                    }
                    type="primary"
                    onClick={() => this.handleAddBid(inquiryData.id)}
                  >
                    Add Bid
                  </Button>
                </div>
              ))}
          </div>
        </Col>
      </div>
    );
  }

  header() {
    const { inquiryData, classes, timezone } = this.props;
    const deadlineData = getDeadlineData(inquiryData.deadline, timezone);
    const { deadline, deadlineString, deadlineColor, isDeadlineNear } = deadlineData;
    return (
      <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
        <div style={{ padding: '12px 24px 0px 16px', width: '26%' }}>
          <div style={{ display: 'flex' }}>
            <div
              style={{
                fontWeight: 'bold',
                fontSize: `${tokens.fontSize.h2}px`,
              }}
            >
              {' '}
              {inquiryData.referenceNumber}
            </div>
            <div style={{ marginLeft: '5px', fontWeight: 'bold', fontSize: `${tokens.fontSize.h2}px` }}>
              <span>|</span> <span>{prettifyInquiryMode[inquiryData.mode]}</span>
            </div>
          </div>
          <div style={{ fontSize: `${tokens.fontSize.small}px`, color: `${deadlineColor}` }}>
            <Tooltip title={isDeadlineNear ? deadline : ''}>
              <Icon
                type="hourglass"
                style={{ marginRight: '8px', fontSize: `${tokens.fontSize.body}px`, color: `${deadlineColor}` }}
              />
              <span>{deadlineString}</span>
            </Tooltip>
          </div>
          {inquiryData?.otherDetails?.isHighValueInsuranceRequired ? <div className={classes.highValue}>High Value Cargo</div> : null}
        </div>
        {this.renderReferenceRateForFF()}
        {this.renderFiltersForFF()}
      </div>
    );
  }

  handleLoadInquiry = async () => {
    const { loadInquiryData } = this.props;
    this.setState({ isInquiryDataLoading: true });
    await loadInquiryData();
    this.setState({ isInquiryDataLoading: false });
  };

  render() {
    const { isLoading, allBidsForFF, inquiryData, classes } = this.props;
    const { isInquiryDataLoading, revokeInquiryModalVisible } = this.state;
    return (
      <div className={classes.parentDiv}>
        <React.Fragment>
          {this.header()}
          <div className={classes.taxWarning}>
            <TaxWarning unit={getUnitByMode(inquiryData.mode)} />
          </div>
        </React.Fragment>
        <div>
        { (isLoading || isInquiryDataLoading) && <div style={{ height: '100%' }}>
            <Loader style={{position: 'fixed'}} zIndex={1} backgroundColor='rgb(255, 255, 255, 0.5)'/>
          </div>
        }
          <div style={{ height: '100%' }}>
            <Col style={{ backgroundColor: '#FCFCFC' }}>
              <div style={{ paddingBottom: '7%', background: COLORS.GREY }}>
                {allBidsForFF && allBidsForFF.length !== 0
                  ? allBidsForFF.map((item, index) => {
                      return (
                        <FFBidCard
                          isLoading={isLoading || isInquiryDataLoading}
                          rank1BidInfo={this.state.rank1BidInfo}
                          cardData={item}
                          key={item.id}
                          inquiryId={inquiryData.id}
                          inquiryData={inquiryData}
                        />
                      );
                    })
                  : this.renderNoData()}
              </div>
            </Col>
          </div>
        </div>
        {revokeInquiryModalVisible && (
          <FFRevokeInquiryModal
            visible={revokeInquiryModalVisible}
            handleCancel={() => this.setState({ revokeInquiryModalVisible: false })}
            handleAddBid={() => this.handleAddBid(inquiryData.id)}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ inquiryFFBidsReducer, masterData, inquiryReducer }, ownProps) => ({
  allBidsForFF: inquiryFFBidsReducer.allBidsForFF,
  isLoading: inquiryFFBidsReducer.isLoading,
  appliedFilters: inquiryFFBidsReducer.appliedFilters,
  pagination: inquiryFFBidsReducer.pagination,
  permission: masterData.permissions.INQUIRY_BIDDING_ALL_ACTIONS,
  currencies: masterData.currencySymbols,
  referenceRateBasis: inquiryReducer.masterData.referenceRateBasis,
  showGapForRank1AllBid: masterData.modules.show_gap_for_rank1_all_bids,
  showGapForRank1: inquiryReducer?.masterData?.showGapForRank1,
  timezone: masterData.timezone,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setFilter,
      applyFilter,
      resetFilters,
      getBidsFF,
    },
    dispatch
  );

const FFInquiryStyled = injectSheet(styles)(FFInquiry);
export default withInquiryMasterData(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withAuthAccessExim([INQUIRY_FF])(FFInquiryStyled))
  )
);
